<div class="p-4 border-round-xl flex flex-column gap-3">
   <div class="flex align-items-center justify-content-between cursor-pointer" (click)="toggleAccordion()">
      <div class="flex flex-row gap-2 align-items-center">
         <i class="pi pi-hourglass text-blue-800"></i>
         <span class="font-semibold text-blue-800">
            {{ 'DATA.MODULES.INSPECTORS.WAIT_DAYS.PREVIEW.REGIONAL_CONFIG_LABEL' | translate }}
         </span>
      </div>
      <i
         class="pi text-blue-800 text-lg transition-all"
         [ngClass]="accordionVisible() ? 'pi-chevron-up' : 'pi-chevron-down'"
      ></i>
   </div>

   <div *ngIf="accordionVisible()" class="flex flex-column gap-3 mt-3">
      <div *ngIf="displayedConfigs().length; else noCollectors" class="flex flex-column gap-3">
         <div
            *ngFor="let group of displayedConfigs()"
            class="p-3 border-round-lg flex flex-column gap-2 bg-white border-1 border-bluegray-100"
         >
            <div class="flex align-items-center justify-content-between">
               <div class="flex flex-column gap-1">
                  <span class="text-500 text-xs">Nombre</span>
                  <span class="text-900 font-semibold">
                     {{ group.description }}
                  </span>
               </div>
               <div class="flex flex-row gap-2 align-items-center px-3 py-2 bg-blue-50 border-round-lg">
                  <i class="pi pi-hourglass text-blue-800"></i>
                  <span class="font-semibold text-sm text-blue-800">{{ group.timezone }}</span>
               </div>
            </div>

            <p-divider class="w-full"></p-divider>

            <div class="flex flex-column gap-1">
               <span class="text-500 text-xs">Perfil de cobro</span>
               <span class="text-600 font-semibold text-sm">
                  {{ getCollectorNames(group) }}
               </span>
            </div>

            <p-divider class="w-full"></p-divider>

            <div class="flex flex-column gap-2">
               <div
                  *ngFor="let entry of getTimetableEntries(group.timetable)"
                  class="flex align-items-center justify-content-between text-xs"
               >
                  <span class="text-500">{{ entry.label }}:</span>
                  <span class="text-900 font-medium">{{ entry.start }} - {{ entry.finish }}</span>
               </div>
            </div>
         </div>
      </div>

      <ng-template #noCollectors>
         <div class="text-center text-500 italic py-4">
            <i class="pi pi-inbox text-2xl mb-2 block"></i>
            {{ 'DATA.MODULES.INSPECTORS.WAIT_DAYS.PREVIEW.NO_CONFIG_INFO' | translate }}
         </div>
      </ng-template>
   </div>
</div>
